export default "__VITE_ASSET__33e0f9ae__"